import { useTranslation } from '@/i18n';
import { TextLink } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, MouseEvent, useMemo } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import styles from './ImportExportHistoryLink.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  source?: ImportExportHistorySource;
  state?: NavigateOptions['state'];
  type?: ImportExportHistoryType;
};

export const enum ImportExportHistorySource {
  custom_transaction_item_options = 'custom_transaction_item_options',
  business_documents = 'business_documents',
}

export const enum ImportExportHistoryType {
  export = 'export',
}

const PATHNAME = '/import_export_histories';

export const ImportExportHistoryLink: FC<Props> = memo(
  ({ source, state, type }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const searchParams = useMemo(() => {
      const params = new URLSearchParams();
      if (source) {
        params.append('source', source);
      }
      if (type) {
        params.append('type', type);
      }
      return params.toString();
    }, [source, type]);

    const handleImportExportHistoryClick = (
      e: MouseEvent<HTMLAnchorElement>
    ) => {
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      navigate({ pathname: PATHNAME, search: searchParams }, { state: state });
    };

    const checkImportExportType = useMemo(() => {
      if (type === ImportExportHistoryType.export) {
        return t('export_history_link_text');
      }
      return t('import_export_history_link_text');
    }, [type, t]);

    return (
      <TextLink
        className={cx(styles['link-button'])}
        href={`${PATHNAME}?${searchParams}`}
        onClick={handleImportExportHistoryClick}
      >
        {checkImportExportType}
      </TextLink>
    );
  }
);
ImportExportHistoryLink.displayName = 'ImportExportHistoryLink';
